import * as z from 'zod';
import { contractSuretyAccountUnderwritingModelSizeSchema, suretyAccountUnderwritingStatusSchema, indemnityAgreementSignatureMethodSchema } from '../../../../enums.mjs';
import '../../../../types/actor/actor.mjs';
import '../../../../types/address/address.mjs';
import '../../../../types/credit-report/company-credit-report.mjs';
import '../../../../types/credit-report/individual-credit-report.mjs';
import '../../../../types/currency/currency.mjs';
import '../../../../types/entityRelation/entity-relation.mjs';
import '../../../../types/financial-formula/adjustable-value.mjs';
import '../../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../../types/financial-formula/adjustment.mjs';
import '../../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../../types/is-encrypted.mjs';
import '../../../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, suretyAccountUnderwritingId, individualContactId, email, companyContactId, suretyIndemnityAgreementId } from '../../../../types/opaque.mjs';
import '../../../../types/surety/account/requested-limits.mjs';
import '../../../../types/surety/account/surety-account.types.mjs';
import '../../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../../types/surety/application-extraction/application-review.mjs';
import '../../../../types/surety/bond/surety-bond.types.mjs';
import '../../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../../types/surety/quote/surety-quote.types.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../../types/user/user.types.mjs';
import '../../../../types/utils.mjs';
import { Get as Get$1 } from '../indemnity-agreement/surety-indemnity-agreement.dto.mjs';

var Get;
(function (Get) {
    (function (Response) {
        (function (Underwriting) {
            Underwriting.schema = z.object({
                id: suretyAccountUnderwritingId,
                status: suretyAccountUnderwritingStatusSchema,
                reviewReasons: z.array(z.object({ description: z.string() })),
                score: z.number().optional(),
                completenessScore: z.number().optional(),
                singleLimit: z.number().optional(),
                aggregateLimit: z.number().optional(),
                expired: z.boolean(),
                expiresAt: isoDateTimeSchema.optional(),
                createdAt: isoDateTimeSchema,
                availableModelSizes: z.array(contractSuretyAccountUnderwritingModelSizeSchema),
                modelSize: contractSuretyAccountUnderwritingModelSizeSchema,
                stale: z.boolean(),
            });
        })(Response.Underwriting || (Response.Underwriting = {}));
        (function (Indemnity) {
            Indemnity.schema = z.object({
                id: suretyIndemnityAgreementId.optional(),
                upToDate: z.boolean(),
                allowedSignatureMethods: z.array(indemnityAgreementSignatureMethodSchema).min(1),
                requiredIndemnitors: z.object({
                    companies: z.array(z.object({
                        id: companyContactId,
                        name: z.string(),
                    })),
                    individuals: z
                        .array(z.object({
                        id: individualContactId,
                        name: z.string(),
                        email: email.optional(),
                    }))
                        .default([]),
                }),
                indemnityWaivers: z.object({
                    companies: z
                        .array(z.object({
                        id: companyContactId,
                        name: z.string(),
                    }))
                        .default([]),
                    individuals: z
                        .array(z.object({
                        id: individualContactId,
                        name: z.string(),
                        email: email.optional(),
                    }))
                        .default([]),
                }),
                indemnityAgreements: z.array(Get$1.Response.schema),
            });
        })(Response.Indemnity || (Response.Indemnity = {}));
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));

export { Get };
